import { useMemo } from "react";
import { useCompany } from "./company";
import { useUser } from "./user";

export const hasLocationConsent = (user) =>
	user?.locationServicesConsent?.at(-1)?.status === true;

export const useGeofencePunchGates = () => {
	const user = useUser();
	const company = useCompany();

	return useMemo(() => {
		const isGeofenceRequired = Boolean(user?.calculationGroup?.geofenceLocation);
		const hasConsent = hasLocationConsent(user);
		const mustAcceptConsent =
			isGeofenceRequired &&
			Boolean(company?.settings?.isGeofenceConsentRequired) &&
			!hasConsent;

		return { isGeofenceRequired, hasConsent, mustAcceptConsent };
	}, [user, company?.settings?.isGeofenceConsentRequired]);
};
